import React from 'react';
import PropTypes from 'prop-types';

import Box from './box';
import Image from './image';
import Label from './label';
import Title from './title';
import Paragraph from './paragraph';
import Tag from './tag';
import Chevron from './chevron';

const Card = (props) => {
    const { image, tags, eyebrow, title, desc, url, ...safeProps } = props;

    const onTagClick = (e, tag) => {
        if (tag.url) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = tag.url;
        }
    };

    const goToUrl = (e, url) => {
        e.preventDefault();
        window.location.href = url;
    };

    return (
        <Box {...safeProps} tag="article" className={`card ${props.className}`}>
            <div className="card__image-wrap">
                <a href={url} title={`Read "${title}"`}>
                    {image ? (
                        <Image className="card__image" {...image} />
                    ) : (
                        <div className="card__image--placeholder" />
                    )}
                </a>
                {tags.length > 0 && (
                    <div className="card__tags">
                        <Tag
                            className="card__tag"
                            color={tags[0].color}
                            tone="normal"
                            role="button"
                            onClick={(e) => onTagClick(e, tags[0])}
                            onKeyUp={(e) =>
                                e.keyCode === 32 && onTagClick(e, tags[0])
                            }
                            tabIndex="0">
                            {tags[0].label}
                        </Tag>

                        {tags.length > 1 && (
                            <Tag className="card__tag" color="grey" tone="dark">
                                +{tags.length - 1}
                            </Tag>
                        )}
                    </div>
                )}
            </div>
            <div className="card__content">
                {eyebrow && (
                    <Label tag="p" className="card__eyebrow">
                        {eyebrow}
                    </Label>
                )}
                <Title level={4} tag="h2" className="card__title">
                    <a href={url} title={`Read "${title}"`}>
                        {title}
                    </a>
                </Title>
                <Paragraph className="card__desc">
                    <span
                        dangerouslySetInnerHTML={{
                            __html: desc,
                        }}
                    />
                </Paragraph>

                {url && (
                    <Chevron
                        className="card__link"
                        aria-label={`Read ${title}`}
                        onClick={(e) => goToUrl(e, url)}
                        onKeyUp={(e) => e.keyCode === 32 && goToUrl(e, url)}
                    />
                )}
            </div>
        </Box>
    );
};

Card.propTypes = {
    className: PropTypes.string,
    image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        srcset: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        alt: PropTypes.string.isRequired,
    }),
    tags: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            url: PropTypes.string,
        }),
    ),
    eyebrow: PropTypes.string,
    title: PropTypes.node.isRequired,
    desc: PropTypes.node.isRequired,
    url: PropTypes.string,
};

Card.defaultProps = {
    className: '',
    tags: [],
    eyebrow: '',
    url: '',
};

export default Card;
